import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import API from '../../../../utils/api';
import PlayerProfiles from '../components/PlayerProfiles';

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('teams', 'setTeams', []),
  withState('players', 'setPlayers', []),
  withState('count', 'setCount', 0),
  withState('page', 'setPage', 0),
  withState('pageSize', 'setPageSize', 10),
  withState('sort', 'setSort', { field: 'firstName', direction: 'asc' }),
  withState('selectedTeam', 'setSelectedTeam', null),
  withState('lastSearch', 'setLastSearch', null),
  withState('dialogOpen', 'setDialogOpen', false),
  withState('errorList', 'setErrorList', { firstName: '', lastName: '' }),
  withHandlers({
    getTeamId: props => teamId => {
      if (!teamId) {
        return null;
      }
      for (const team of props.teams) {
        if (teamId && team._id.toString() === teamId.toString()) {
          return team._id;
        }
      }

      return null;
    },
  }),
  withHandlers({
    refreshPlayers: props => (team, search, sort, teamChange) => {
      try {
        const params = {
          page: props.page + 1,
          pageSize: props.pageSize,
          select: 'firstName lastName playerId photo teamId',
        };

        if (sort) {
          params.sort = JSON.stringify({
            [sort.field]: sort.direction === 'desc' ? -1 : 1,
          });
        } else {
          params.sort = JSON.stringify({
            [props.sort.field]: props.sort.direction === 'desc' ? -1 : 1,
          });
        }

        if (search) {
          const query = {
            teamId: team ? team : teamChange ? null : props.getTeamId(props.selectedTeam),
            $or: [
              { firstName: { $regex: search.toString(), $options: 'i' } },
              { lastName: { $regex: search.toString(), $options: 'i' } },
            ],
          };
          params.query = JSON.stringify(query);
        } else {
          params.query = JSON.stringify({
            teamId: team ? team : teamChange ? null : props.getTeamId(props.selectedTeam),
          });
        }

        API.getPlayers(params).then(({ players, teams }) => {
          props.setPlayers(players.docs);
          props.setCount(players.total);
        });
      } catch (error) {
        console.error(error);
      }
    },
  }),
  withHandlers({
    onChangePage: props => (_event, page) => {
      props.setPage(page, () => {
        props.refreshPlayers(props.getTeamId(props.selectedTeam), props.lastSearch);
      });
    },
    onChangeRowsPerPage: props => event => {
      props.setPageSize(event.target.value, () => {
        props.refreshPlayers(props.getTeamId(props.selectedTeam), props.lastSearch);
      });
    },
    changeTeam: props => (team, search, sort) => {
      props.setSelectedTeam(team);
      props.refreshPlayers(team, search, sort, true);
    },
    sortTable: props => (sort, search) => {
      props.setSort(sort);
      props.refreshPlayers(
        props.getTeamId(props.selectedTeam),
        search && search !== '' ? search : null,
        sort
      );
    },
  }),
  lifecycle({
    componentDidMount() {
      API.getTeams({ ignoreDependencies: true }).then(({ data }) => {
        if (data && data.docs) {
          this.props.setTeams(data.docs);
        }
      });
      this.props.refreshPlayers();
    },
    componentWillUnmount() {},
  })
);

export default enhance(PlayerProfiles);
